import styled, { css } from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
`;

export const Label = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  min-width: 0;
`;

export const ClickableLabel = styled.button`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.primary[600]};
  min-width: 0;
  flex: 1;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: ${rawColors.primary[700]};
  }
`;

const linkIconStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${rawColors.primary[500]};
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const ExternalLinkButton = styled.a`
  ${linkIconStyles}
  text-decoration: none;
`;

export const FocusLinkButton = styled.button`
  ${linkIconStyles}
`;
